import { Link } from 'react-router-dom'
import CertifiedBadge from './CertifiedBadge'

function historyHeadline(item) {
  if (item?.kind === 'rollback') {
    const hash = item.target_commit_hash ? item.target_commit_hash.slice(0, 7) : 'previous commit'
    const message = item.target_commit_message ? ` — ${item.target_commit_message}` : ''
    return `Rolled back to ${hash}${message}`
  }
  if (item?.kind === 'merge') {
    const branch = item.source_branch ? `${item.source_branch} into main` : 'into main'
    const message = item.message ? ` — ${item.message}` : ''
    return `Merged ${branch}${message}`
  }
  return item?.message || ''
}

function formatTimeAgo(dateString) {
  const date = new Date(dateString)
  const now = new Date()
  const diffMs = now - date
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)
  if (diffMins < 60) return `${diffMins} minutes ago`
  if (diffHours < 24) return `${diffHours} hours ago`
  if (diffDays < 30) return `${diffDays} days ago`
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

function kindLabel(kind) {
  if (kind === 'auto_merge') return 'Commit (auto merge)'
  if (kind === 'merged') return 'Merged'
  if (kind === 'merge') return 'Merge'
  if (kind === 'rollback') return 'Rollback'
  return 'Commit'
}

function isCommitKind(kind) {
  return kind === 'commit' || kind === 'auto_merge' || kind === 'merged'
}

export default function CommitHistoryList({ items, className = '', onReport, linkProfiles = true }) {
  return (
    <div className={className}>
      {items.map((item) => {
        const kind = item.kind || 'commit'
        const hash = kind === 'rollback' ? item.target_commit_hash : item.commit_hash
        const tone = item.rolled_back
          ? ' commit-history-item--rolled-back'
          : item.current
            ? ' commit-history-item--current'
            : ''
        return (
          <div
            key={`${kind}-${item.id}`}
            className={`commit-history-item${tone}`}
          >
            <div className="commit-history-message">
              <span className={`commit-history-kind commit-history-kind--${kind}`}>{kindLabel(kind)}</span>
              {historyHeadline(item)}
            </div>
            <div className="commit-history-meta">
              {hash && (
                <span className="commit-hash" title={hash}>
                  {hash.slice(0, 7)}
                </span>
              )}
              {item.author_username && item.author_id && (
                linkProfiles ? (
                  <Link to={`/users/${item.author_id}`} className="commit-author">
                    {item.author_username}
                    <CertifiedBadge
                      user={{
                        is_founding_contributor: item.author_is_founding_contributor,
                        forum_certified: item.author_forum_certified,
                      }}
                    />
                  </Link>
                ) : (
                  <span className="commit-author">
                    {item.author_username}
                    <CertifiedBadge
                      user={{
                        is_founding_contributor: item.author_is_founding_contributor,
                        forum_certified: item.author_forum_certified,
                      }}
                    />
                  </span>
                )
              )}
              <span className="commit-time">{formatTimeAgo(item.created_at)}</span>
              {isCommitKind(kind) && onReport && (
                <button
                  type="button"
                  className="report-link report-link-inline"
                  onClick={() => onReport(item)}
                  title="Report this commit"
                >
                  Report
                </button>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
